import moment from 'moment';
import Snap from "Snap.svg/dist/snap.svg";
import {cloneDeep} from "lodash-es";

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'SnapService';

export const SnapConst = {
  Shapes: {
    Circle: 'circle',
    Rect: 'rect',
    Square: 'square'
  },
  Colors: {
    Accent: '#A91164'
  },
  Aligns: {
    TopLeft: {
      id: 0,
      value: [0, 0]
    },
    TopCenter: {
      id: 1,
      value: [0, 1]
    },
    TopRight: {
      id: 2,
      value: [0, 2]
    },
    CenterLeft: {
      id: 3,
      value: [1, 0]
    },
    CenterCenter: {
      id: 4,
      value: [1, 1]
    },
    CenterRight: {
      id: 5,
      value: [1, 2]
    },
    BottomLeft: {
      id: 6,
      value: [2, 0]
    },
    BottomCenter: {
      id: 7,
      value: [2, 1]
    },
    BottomRight: {
      id: 8,
      value: [2, 2]
    }
  },
  Gesture: {
    dragThreshold: 10,
    pressThreshold: 500,
    clickThreshold: 250,
    clickBreak: 50,
    pinchSpreadThreshold: 20
  },
  isTouch: 'ontouchstart' in document.documentElement,
  isMouse: 'onmousedown' in document.documentElement,

  allowHTMLTransform: false // label placing bugged in this mode EPBI-1528
};


export default function SnapService(SnapConst) {
  "ngInject";

  var service = {
    //Gestures
    enableGestures: enableGestures,
    isEnabled: isEnabled,
    normalizeEventPositions: normalizeEventPositions,
    onClick: onClick,
    onDrag: onDrag,
    startDraggingFromEvent: startDraggingFromEvent,
    addScroll: addScroll,
    onPinchSpread: onPinchSpread,
    //Geometric operations
    sumPositions: sumPositions,
    diffPositions: diffPositions,
    moveBox: moveBox,
    mergeBoxes: mergeBoxes,
    getShapeCenter: getShapeCenter,
    getShapeAlignedPosition: getShapeAlignedPosition,
    fixPosition: fixPosition,
    roundMatrixSplit: roundMatrixSplit,
    getRectCorners: getRectCorners,
    getRectBox: getRectBox,
    get2PointsDistance: get2PointsDistance,
    isTouch: isTouch,
    getLineFormula: getLineFormula,
    get2LineIntercept: get2LineIntercept,
    //Element operations
    buildElement: buildElement,
    getElement: getElement,
    getTranformationData: getTranformationData,
    setTranformationData: setTranformationData,
    getTransform: getTransform,
    applyTransformation: applyTransformation,
    setTranslateLimit: setTranslateLimit,
    getTranslateLimit: getTranslateLimit,
    setStep: setStep,
    getStep: getStep,
    getShape: getShape,
    getCenter: getCenter,
    getPosition: getPosition,
    getRotation: getRotation,
    getScale: getScale,
    getTextWidth: getTextWidth,
    show: show,
    place: place,
    scale: scale,
    rotate: rotate,
    calcBBox: calcBBox,
    resetBBox: resetBBox,
    printBBox: printBBox,
    //Utils
    printExecutionTime: printExecutionTime,
    getDuration: getDuration,
    setEllipsis: setEllipsis,
    applyEllipsis: applyEllipsis,
    initMultitextPlugin
  };
  return service;

  function log() {
    // if (false) { console.log(arguments); }
  }

  /************************************************************************************************************************
   *************************************************************************************************************************
   ENABLE GESTURES
   *************************************************************************************************************************
   ************************************************************************************************************************/
  function enableGestures(element, enable) {
    var e = getElement(element);
    var input = enable === false ? false : true;
    e.attr('data-gestures', input);
  }

  function isEnabled(element) {
    var e = getElement(element);
    return e.attr('data-gestures') === 'false' ? false : true;
  }

  function normalizeEventPositions(event) {
    if (event && event.type) {
      if (!isTouch(event)) {
        //mouse
        //log('Normalize mouse evt');
        if (event.clientX && event.clientY) {
          if (!event.x) {
            event.x = event.clientX;
          }
          if (!event.y) {
            event.y = event.clientY;
          }
        }
      } else {
        //touch
        log('Normalize touch evt', _.size(event.touches), _.size(event.changedTouches));
        if (_.isEmpty(event.touches) && _.isEmpty(event.changedTouches)) {
          log('Invalid touch event, no touches!');
          return false;
        }
        event.x = _.first(event.touches) != null ? _.first(event.touches).clientX : _.first(event.changedTouches).clientX;
        event.y = _.first(event.touches) != null ? _.first(event.touches).clientY : _.first(event.changedTouches).clientY;
        _.each(event.touches, function (touch) {
          touch.x = touch.clientX;
          touch.y = touch.clientY;
        });
        _.each(event.changedTouches, function (touch) {
          touch.x = touch.clientX;
          touch.y = touch.clientY;
        });
      }
      return true;
    } else {
      return false;
    }
    //log('normalized', JSON.stringify(event));
  }

  function isTouch(event) {
    return event && event.type && event.type.indexOf('touch') >= 0;
  }

  /************************************************************************************************************************
   *************************************************************************************************************************
   REGISTER GESTURES
   *************************************************************************************************************************
   ************************************************************************************************************************/
  function registerGestureStart(element, allowPassThrough, startedCallback) {
    var e = getElement(element);
    if (!e.data('gesture')) {
      e.data('gesture', true);
      //log('Register gesture start on '+element.name);
      var startFunc = function (evt) {
        //log('Gesture start on '+element.name);
        if (isEnabled(element) && normalizeEventPositions(evt)) {
          //log('touches', _.size(evt.touches), 'changedTouches', _.size(evt.changedTouches));
          if (isTouch(evt) && isMultiTouch(evt)) { //PinchSpread
            //Remove start when detect pinch (touch event and touches or changedTouches > 1)
            log('onPinchSpread.touchstart');
            e.data('touch', {
              touches: evt.touches,
              distance: get2PointsDistance(evt.touches[0], evt.touches[1])
            });
            //Remove eventual drag and start data, 2 touches override them
            e.data('start', null);
            e.data('drag', null);
            log('removed data.start and data.drag!');
          } else {
            //Add start info when mouse event or touch event and touches or changedTouches == 1
            //Not PinchSpread
            var position = {
              x: evt.x,
              y: evt.y
            };
            e.data('start', {
              pos: position,
              lastPos: cloneDeep(position),
              time: moment(),
              isTouch: isTouch(evt)
            });
            log(evt, 'set data.start! touch:', isTouch(evt), evt.touches, evt.changedTouches);
          }
        }

        if (startedCallback) {
          startedCallback();
        }

        /**
         * Setting allowPassThrough to true fixes issue where pinch zoom wasn't working on floorplan
         * when the touch origin was over a table.
         */
        if (!allowPassThrough) {
          evt.preventDefault();
          evt.stopPropagation();
          return false;
        }
      }; //startFunc

      e.touchstart(startFunc);
      e.mousedown(startFunc);

      return function () {
        e.untouchstart(startFunc);
        e.unmousedown(startFunc);
      };
    }
  }

  /**
   * Click handler for Snap SVG elements
   * @param {SnapSVG Element} element - target element
   * @param {Function} handler - handler for click
   * @param {object} context - 'this' context for click
   * @param {boolean} allowPassThrough - whether or not to stop propagating the click event (passed to `registerGestureStart`)
   * @param {Function} skippedHandler - if the click gets skipped because the up/end event has moved since the down/start event, this handler gets called
   */
  function onClick(element, handler, context, allowPassThrough, skippedHandler) {

    const el = getElement(element);
    const MOVE_EVENT_TYPE = 'moveEvent';

    const endFunc = function (evt, eventType) {
      const isMoveEvent = eventType === MOVE_EVENT_TYPE;

      if (isEnabled(element) && el.data('start') && normalizeEventPositions(evt)) {
        var now = moment();
        var delta = diffPositions(evt, el.data('start').pos);
        var proceed =
          Math.abs(delta.x) <= SnapConst.Gesture.dragThreshold &&
          Math.abs(delta.y) <= SnapConst.Gesture.dragThreshold &&
          now.diff(el.data('start').time) <= SnapConst.Gesture.clickThreshold &&
          (el.data('lastclick') == null || now.diff(el.data('lastclick')) >= SnapConst.Gesture.clickBreak);

        if (!isMoveEvent && proceed) {
          el.data('lastclick', moment());
          el.data('start', null);
          _.bind(handler, context, evt)();
        } else {
          if (isMoveEvent) {
            skippedHandler(evt, el);
          }
          log('onClick skipped', delta, moment().diff(el.data('start').time));
        }
      }
    };

    el.touchend(endFunc);
    el.mouseup(endFunc);

    let moveFunc;
    if (skippedHandler) {
      moveFunc = evt => {
        endFunc(evt, MOVE_EVENT_TYPE);
        document.body.removeEventListener('touchmove', moveFunc);
        document.body.removeEventListener('mousemove', moveFunc);
      };
    }


    var unregisterGesture = registerGestureStart(element, allowPassThrough, () => {
      if (moveFunc) {
        document.body.addEventListener('touchmove', moveFunc);
        document.body.addEventListener('mousemove', moveFunc);
      }
    });

    return function () {
      el.untouchend(endFunc);
      el.unmouseup(endFunc);

      if (unregisterGesture) {
        unregisterGesture();
      }
    };
  }

  /**
   * Takes any mouse or touch event, plus a target element, and starts using it to trigger a drag.
   * The event system used by SnapSVG is exposed on as `window.eve` and gets used here to tell Snap to start the
   * drag using the provided event for x/y coords.
   * @param {*} snapEl
   * @param {*} evt
   */
  function startDraggingFromEvent(snapEl, evt, ignoreMultiTouch) {
    if (ignoreMultiTouch && isMultiTouch(evt)) {
      return;
    }

    var position = {
      x: evt.x,
      y: evt.y
    };
    snapEl.data('start', {
      pos: position,
      lastPos: cloneDeep(position),
      time: moment(),
      isTouch: isTouch(evt)
    });
    window.eve("snap.draginit." + snapEl.id, snapEl, evt, evt.x, evt.y);
  }

  function isMultiTouch(evt) {
    if (!evt) {
      return false;
    }
    return (evt.touches && evt.touches.length > 1 || evt.changedTouches && evt.changedTouches.length > 1);
  }

  /**
   * options.hold - Default false, if true the element is not moved, but all info are provided back to callbacks for usage
   * options.restore - Default false, if true the element is placed back to its original position before endMove callback
   * options.clone - Create a clone to be dragged and append it to the parents scaled element or the svg root, remove it at dragEnd
   * options.shift - If true show the dragged element shifted away from the action source (cursor/finger) to the bottom/right
   *
   * info.original     [SME] - The snap requested for drag action
   * info.element      [SME] - The snap element subject of the drag action
   * info.clone        [_ME] - The cloned element used for drag in case of clone or hold option enabled
   * info.evt          [SME] - The snap drag (start or move or end) current event
   * info.screenFrom   [SME] - Drag screen/action initial coordinates
   * info.from         [SME] - The element initial position relative to its container in the SVG environment
   * info.screenTo     [_ME] - The screen/action actual coordinates
   * info.to           [_ME] - The element actual position relative to its container in the SVG environment
   * info.delta        [_ME] - The movement done since drag start to actual
   */
  function onDrag(element, context, onMove, onStart, onEnd, options) {
    var unregisterGesture = registerGestureStart(element);

    context = context || this;
    options = options || {};
    var e = getElement(element);
    const elCenter = getCenter(element);
    let delayTime = null;

    e.drag(
      function (dx, dy, mx, my, evt) { //onMove

        if ((e.data('start') != null || (e.data('drag') != null && e.data('drag').moved))) {

          /**
           * When dragging/panning the floor plan, you don't want to accidently move a booking,
           * so here we add a small delay so the user must hold the booking before dragging it.
           */
          if (Date.now() < delayTime) {
            return;
          }

          // if pinching, don't want booking to start dragging
          if (isMultiTouch(evt.originalEvent)) {
            return;
          }

          normalizeEventPositions(evt);

          //log('start', e.data('start'), 'drag', e.data('drag'));
          if (Math.abs(dx) > SnapConst.Gesture.dragThreshold || Math.abs(dy) > SnapConst.Gesture.dragThreshold) {
            var dm = roundMatrixSplit(e.transform().diffMatrix.split());
            if (!e.data('drag').moved) {
              e.data('drag').moved = true;
              e.data('drag').isTouch = e.data('start').isTouch;
              e.data('start', null);
              if (options.clone || options.hold) {

                const dragEl = getClonedDragBooking(e);

                e.data('drag').clone = dragEl;
                e.data('drag').element = dragEl;

                var cc = e.parent();
                while (getScale(cc).x === 1 && getScale(cc).y === 1 && cc.type !== 'svg') {
                  cc = cc.parent();
                }
                dragEl.appendTo(cc);
                e.data('drag').container = cc;
                if (options.hold) {
                  dragEl.addClass('hidden');
                }
                var m = e.transform().globalMatrix;
                m = m.add(e.data('drag').container.transform().globalMatrix.invert());
                var ms = roundMatrixSplit(m.split());

                var tr = {
                  x: ms.dx / e.transform().globalMatrix.split().scalex,
                  y: ms.dy / e.transform().globalMatrix.split().scaley,
                  sx: ms.scalex,
                  sy: ms.scaley,
                  r: ms.rotate,
                  rx: 0,
                  ry: 0
                };
                setTranformationData(dragEl, tr);
                applyTransformation(dragEl);
                e.data('drag').from = getPosition(dragEl);
              }
              if (options.shift) {
                var gPos = e.transform().globalMatrix.split();
                var svgPosition = {
                  x: e.paper.node.getBoundingClientRect().left,
                  y: e.paper.node.getBoundingClientRect().top
                };
                var mouseSvgPosition = diffPositions(e.data('drag').screenFrom, svgPosition);
                gPos = diffPositions(mouseSvgPosition, {
                  x: gPos.dx,
                  y: gPos.dy
                });

                var shiftMargin = {
                  x: (-elCenter.x * dm.scalex),
                  y: (-elCenter.y * dm.scaley)
                };
                var deltaShift = sumPositions(gPos, shiftMargin);
                deltaShift.x /= dm.scalex;
                deltaShift.y /= dm.scaley;
                e.data('drag').shift = deltaShift;
              }
              if (typeof onStart === 'function') {
                //log('SS.onDrag.onStart');
                _.bind(onStart, context, e.data('drag'))();
              }
            } //dragStart

            //Moving
            //Update drag info
            e.data('drag').evt = evt;
            e.data('drag').screenTo = {
              x: mx,
              y: my
            };

            //apply only when there's a zoom difference between element and its parent container
            var deltaLogicPos = {
              x: dx / dm.scalex,
              y: dy / dm.scaley
            };
            var nextLogicPos = sumPositions(e.data('drag').from, deltaLogicPos, e.data('drag').shift);
            //Need to use absolute place operation as object adjust at each moved but dx,dy are referenced to drag start
            place(e.data('drag').element, nextLogicPos.x, nextLogicPos.y);
            // Get post data
            e.data('drag').to = getPosition(e.data('drag').element);
            e.data('drag').delta = diffPositions(e.data('drag').to, e.data('drag').from);
            if (typeof onMove === 'function') {
              _.bind(onMove, context, e.data('drag'))();
            }
          }
        }
      },
      function (x, y, evt) { //onStart

        if (e.data('start')) { //normalizeEventPositions(evt) &&
          log('set data.drag!');

          const isBookingEl = evt.target && evt.target.closest('[data-name="booking"]');

          delayTime = Date.now() + (isBookingEl ? 800 : 0);
          e.data('drag', {
            element: e,
            original: e,
            evt: evt,
            shift: {
              x: 0,
              y: 0
            },
            screenFrom: {
              x: x,
              y: y
            },
            from: getPosition(e)
          });
        }
      },
      function (evt) { //onEnd
        delayTime = null;
        if (normalizeEventPositions(evt) && e.data('drag') && e.data('drag').moved) {
          if (e.data('drag').clone) {
            //Destroy clone
            e.data('drag').clone.remove();
          } else {
            //Original element moved, unshift it and eventually restore original position
            if (options.restore) {
              //Place back the dragged element
              place(e.data('drag').element, e.data('drag').from.x, e.data('drag').from.y);
            } else if (options.shift) {
              //Unshift the element to its real final position
              var adjustShift = diffPositions(e.data('drag').to, e.data('drag').shift);
              place(e.data('drag').element, adjustShift.x, adjustShift.y);
            }
          }
          if (typeof onEnd === 'function') {
            //log('SS.onDrag.onEnd');
            _.bind(onEnd, context, e.data('drag'))();
          }
          e.data('drag', null);
        }
      }
    ); //drag

    return function () {
      e.undrag();
      if (unregisterGesture) {
        unregisterGesture();
      }
    };
  } //onDrag


  /**
   * Create a copy of the booking element to for dragging.
   * @param e - element from 'getElement' method
   */
  function getClonedDragBooking(e) {
    const dragEl = e.clone();

    /**
     * pointer events needed to be removed so that cursor could drag from on top of the element
     * but still be able to register when coords intersect with other tables.
     */
    const groupNode = dragEl.node;
    groupNode.style.pointerEvents = 'none';

    // just makes the dragged UI look a little prettier
    const rect = dragEl.node.querySelector('rect');
    rect.style.fill = '#dadada';
    rect.setAttribute('width', '76');
    rect.setAttribute('height', '76');
    rect.setAttribute('x', '-10');
    rect.setAttribute('y', '-10');
    rect.setAttribute('rx', '5');
    rect.setAttribute('ry', '5');

    return dragEl;
  }
  0
  function onPinchSpread(element, handler, context) {
    var unregisterGesture = registerGestureStart(element);
    var el = getElement(element);

    var moveHandler = function (evt) {
      if (normalizeEventPositions(evt) && el.data('touch')) {
        var distance = get2PointsDistance(evt.touches[0], evt.touches[1]);
        log('onPinchSpread.touchmove', distance);
        var diff = distance - el.data('touch').distance;
        log('onPinchSpread.touchmove', diff);
        if (Math.abs(diff) > SnapConst.Gesture.pinchSpreadThreshold) {
          el.data('touch').distance = distance;
          var step = diff > 0 ? 1 : -1;
          log('SS.onPinchSpread', step);
          _.bind(handler, context, step)();
        }
      }
    };

    var endHandler = function () {
      if (el.data('touch')) {
        el.data('touch', null);
        log('onPinchSpread.touchend');
      }
    };

    el.touchmove(moveHandler);
    el.touchend(endHandler);

    return function () {
      el.untouchmove(moveHandler);
      el.untouchend(endHandler);
      if (unregisterGesture) {
        unregisterGesture();
      }
    };
  }

  function addScroll(element, handler, context) {
    context = context || this;
    var el = getElement(element);
    var evtHandler = function (e) {
      // cross-browser wheel delta
      e = window.event || e; // old IE support
      var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      if (typeof handler === 'function') {
        _.bind(handler, context, delta)();
      }
    };
    if (el.node.addEventListener) {
      el.node.addEventListener('mousewheel', evtHandler, false);
      el.node.addEventListener('DOMMouseScroll', evtHandler, false);
    } else {
      el.attachEvent('onmousewheel', evtHandler);
    }
    // Return handler destroyer
    return function () {
      if (el.node.addEventListener) {
        el.node.removeEventListener('mousewheel', evtHandler);
        el.node.removeEventListener('DOMMouseScroll', evtHandler);
      } else {
        el.detachEvent('onmousewheel', evtHandler);
      }
    };
  }

  /************************************************************************************************************************
   *************************************************************************************************************************
   GEOMETRIC OPERATIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/
  function sumPositions() {
    var result = {
      x: 0,
      y: 0
    };
    _.each(arguments, function (delta) {
      if (delta) {
        if (delta.x) {
          result.x += delta.x;
        }
        if (delta.y) {
          result.y += delta.y;
        }
      }
    });
    return result;
  }

  function diffPositions() {
    var result = arguments.length === 0 ? {
      x: 0,
      y: 0
    } : {
      x: arguments[0].x,
      y: arguments[0].y
    };
    _.each(arguments, function (delta, index) {
      if (delta && index > 0) {
        if (delta.x) {
          result.x -= delta.x;
        }
        if (delta.y) {
          result.y -= delta.y;
        }
      }
    });
    return result;
  }

  function moveBox(box, position) {
    if (box) {
      var d = position || {
        x: 0,
        y: 0
      };
      var res = {
        x: box.x + d.x,
        x2: box.x2 + d.x,
        y: box.y + d.y,
        y2: box.y2 + d.y,
        w: box.w,
        h: box.h
      };
      return res;
    }
    return box;
  }

  function mergeBoxes() {
    var inputs = _.compact(arguments);
    if (inputs.length) {
      var result = {
        x: Infinity,
        y: Infinity,
        x2: 0,
        y2: 0,
        w: 0,
        h: 0
      };

      _.each(inputs, function (box) {
        result.x = Math.min(result.x, box.x);
        result.y = Math.min(result.y, box.y);
        result.x2 = Math.max(result.x2, box.x2);
        result.y2 = Math.max(result.y2, box.y2);
      });
      result.x = result.x === Infinity ? 0 : result.x;
      result.y = result.y === Infinity ? 0 : result.y;
      result.w = result.x2 - result.x;
      result.h = result.y2 - result.y;
      return result;
    }
    return null;
  }

  function getShapeCenter(shape) {
    return {
      x: shape.w / 2,
      y: shape.h / 2
    };
  }

  function getShapeAlignedPosition(pos, shape, align) {
    if (!align) {
      return pos;
    }
    var result = {
      x: pos.x,
      y: pos.y
    };
    //apply align if available
    if (shape) {
      result.x -= (shape.w / 2) * align.value[1];
      result.y -= (shape.h / 2) * align.value[0];
    }
    return result;
  }

  function fixPosition(from, to, translateLimit, step, bbox) {
    step = step ? step : {
      x: 1,
      y: 1
    };
    // Snap based on the element's visual bounding box so rotations and
    // negative child offsets (e.g. chairs that extend outside the root)
    // align consistently on the grid. The bbox provided is for the element
    // at position `from`, so the offset between the transform origin and the
    // visual top-left is constant during translation.
    var offsetX = bbox ? (bbox.x - from.x) : 0;
    var offsetY = bbox ? (bbox.y - from.y) : 0;
    
    // Apply a global offset to align table bodies to the grid instead of chairs
    var GRID_OFFSET = 8;
    offsetX += GRID_OFFSET;
    offsetY += GRID_OFFSET;
    to = {
      x: Math.round((to.x + offsetX) / step.x) * step.x - offsetX,
      y: Math.round((to.y + offsetY) / step.y) * step.y - offsetY
    };
    if (translateLimit) {
      var delta = diffPositions(to, from);
      var nextBbox = {
        x: bbox.x + delta.x,
        y: bbox.y + delta.y,
        x2: bbox.x2 + delta.x,
        y2: bbox.y2 + delta.y,
        h: bbox.h,
        w: bbox.w
      };
      if (translateLimit.right != null && nextBbox.x2 > translateLimit.right) {
        to.x -= (nextBbox.x2 - translateLimit.right);
        to.x = Math.floor(to.x / step.x) * step.x;
      }
      if (translateLimit.left != null && nextBbox.x < translateLimit.left) {
        to.x += (translateLimit.left - nextBbox.x);
        to.x = Math.ceil(to.x / step.x) * step.x;
      }
      if (translateLimit.bottom != null && nextBbox.y2 > translateLimit.bottom) {
        to.y -= (nextBbox.y2 - translateLimit.bottom);
        to.y = Math.floor(to.y / step.y) * step.y;
      }
      if (translateLimit.top != null && nextBbox.y < translateLimit.top) {
        to.y += (translateLimit.top - nextBbox.y);
        to.y = Math.ceil(to.y / step.y) * step.y;
      }
    }
    return to;
  }

  function roundMatrixSplit(ms) {
    var dec = 3;
    return {
      dx: _roundDecimalPrecision(ms.dx, dec),
      dy: _roundDecimalPrecision(ms.dy, dec),
      scalex: _roundDecimalPrecision(ms.scalex, dec),
      scaley: _roundDecimalPrecision(ms.scaley, dec),
      shear: _roundDecimalPrecision(ms.shear, dec),
      rotate: _roundDecimalPrecision(ms.rotate, dec),
      isSimple: ms.isSimple,
      siSuperSimple: ms.isSuperSimple,
      noRotation: ms.noRotation
    };
  }

  function _roundDecimalPrecision(num, dec) {
    return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  }

  function getRectBox(size, position, rotation) {
    var corners = getRectCorners(size, position, rotation);
    var bbox = {
      x: corners[0].x,
      x2: corners[0].x,
      y: corners[0].y,
      y2: corners[0].y
    };
    _.times(3, function (n) {
      var corner = corners[n + 1];
      bbox.x = Math.min(bbox.x, corner.x);
      bbox.x2 = Math.max(bbox.x2, corner.x);
      bbox.y = Math.min(bbox.y, corner.y);
      bbox.y2 = Math.max(bbox.y2, corner.y);
    });
    bbox.w = bbox.x2 - bbox.x;
    bbox.h = bbox.y2 - bbox.y;
    return bbox;
  }

  function getRectCorners(size, position, rotation) {
    var corners = [];
    var rad = rotation * (Math.PI / 180);
    var center = getShapeCenter(size);
    _.times(4, function (n) {
      var corner, tcorner;
      switch (n) {
        case 0: //Left Top corner
          corner = {
            x: 0,
            y: 0
          };
          tcorner = diffPositions(corner, center);
          break;
        case 1: //Right Top corner
          corner = {
            x: size.w,
            y: 0
          };
          tcorner = diffPositions(corner, center);
          break;
        case 2: //Right Bottom corner
          corner = {
            x: size.w,
            y: size.h
          };
          tcorner = diffPositions(corner, center);
          break;
        case 3: //Left Bottom corner
          corner = {
            x: 0,
            y: size.h
          };
          tcorner = diffPositions(corner, center);
          break;
      }
      var rcorner = {
        x: _roundDecimalPrecision(tcorner.x * Math.cos(rad) - tcorner.y * Math.sin(rad), 5),
        y: _roundDecimalPrecision(tcorner.x * Math.sin(rad) + tcorner.y * Math.cos(rad), 5)
      };
      corners.push(sumPositions(rcorner, center, position));
    });
    return corners;
  }

  function get2PointsDistance(a, b) {
    return Math.sqrt(Math.pow((a.x - b.x), 2) + Math.pow((a.y - b.y), 2));
  }

  function getLineFormula(a, b) {
    var f = {
      s: (a.y - b.y) / (a.x - b.x)
    };
    f.i = a.y - f.s * a.x;
    f.vertical = f.s === Infinity;
    return f;
  }

  function get2LineIntercept(l1, l2) {
    var pos = {};
    pos.x = (l2.i - l1.i) / (l1.s - l2.s);
    pos.y = l1.i * pos.x + l1.i;
    return pos;
  }

  /************************************************************************************************************************
   *************************************************************************************************************************
   ELEMENT OPERATIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/
  function buildElement(s, shape) {
    var r = shape.type === SnapConst.Shapes.Circle ? 100 : 0;
    var e = s.rect(0, 0, shape.w, shape.h, r, r);
    e.addClass(shape.type);
    return e;
  }

  function getElement(element) {
    if (typeof element.getSGroup === 'function') {
      return element.getSGroup();
    } else {
      return element;
    }
  }

  function getTranformationData(element) {
    var tr = getElement(element).data().tr;
    if (!tr) {
      tr = {
        x: 0,
        y: 0,
        r: 0,
        rx: 0,
        ry: 0,
        sx: 1,
        sy: 1,
        scx: 0,
        scy: 0
      };
      getElement(element).data().tr = tr;
    }
    return tr;
  }

  function setTranformationData(element, tr) {
    getElement(element).data().tr = tr;
  }

  function getTransform(element) {
    var tr = getTranformationData(element);
    return 'T' + (tr.x / tr.sx) + ',' + (tr.y / tr.sy) + 'S' + tr.sx + ',' + tr.sy + ',' + tr.scx + ',' + tr.scy + 'r' + tr.r + ',' + tr.rx + ',' + tr.ry;
  }

  function applyTransformation(element) {
    var transformation = getTransform(element);
    if (window.useHTMLTransformation && SnapConst.allowHTMLTransform) {
      // html transform - NOT WORKING ON DRAG!
      var m = Snap._.transform2matrix(transformation);
      var matrixStr = "matrix(" + [m.a, m.b, m.c, m.d, m.e, m.f].join() + ")";
      getElement(element).node.setAttribute('transform', matrixStr);
    } else {
      // snap transform
      getElement(element).attr({
        transform: transformation
      });
    }
  }

  function setTranslateLimit(element, translateLimit) {
    getElement(element).data().translatelimit = translateLimit;
  }

  function getTranslateLimit(element) {
    return getElement(element).data().translatelimit;
  }

  function setStep(element, step) {
    getElement(element).data().step = step;
  }

  function getStep(element) {
    return getElement(element).data().step;
  }

  function show(element, visible) {
    var e = getElement(element);
    if (visible) {
      e.removeClass('hidden');
    } else {
      e.addClass('hidden');
    }
  }

  function getShape(element) {
    if (element.shape && element.shape.w && element.shape.h) {
      return element.shape;
    } else {
      var el = getElement(element);
      var bb = calcBBox(el);
      var type = (element.shape && element.shape.type) ? element.shape.type : SnapConst.Shapes.Rect;
      return {
        type: type,
        w: bb.w,
        h: bb.h,
        x: bb.x,
        y: bb.y
      };
    }
  }

  function getPosition(element) {
    var elementPos = getTranformationData(element);
    var pos = {
      /**
       * There is an interface on the back end that expects int values on this Position object, so we must round them.
       * https://dev.azure.com/NBI-ORG/_git/NBI-API?path=/BookItBackend/CouchClient/Entities/Section.cs
       * Strangely, this breaks getSchedule on widget, even though position isn't loaded or used in the widget.
       */
      x: Math.round(elementPos.x),
      y: Math.round(elementPos.y)
    };
    return pos;
  }

  function getRotation(element) {
    return getTranformationData(element).r;
  }

  function getScale(element) {
    var tr = getTranformationData(element);
    return {
      x: tr.sx,
      y: tr.sy
    };
  }

  function getTextWidth(text) {
    return text ? text.node.getComputedTextLength() : 0;
  }

  function getCenter(element) {
    return getShapeCenter(getShape(element));
  }

  function place(element, absX, absY, align, shape) {
    var e = getElement(element);
    var from = getPosition(element);
    var translateLimit = getTranslateLimit(element);
    var step = getStep(element);
    var to = {
      x: absX,
      y: absY
    };
    if (align) {
      if (!shape) {
        shape = getShape(element);
      }
      to = getShapeAlignedPosition(to, shape, align);
    }
    if (step || translateLimit) {
      to = fixPosition(from, to, translateLimit, step, calcBBox(e));
    }
    var tr = getTranformationData(element);
    tr.x = to.x;
    tr.y = to.y;
    applyTransformation(element);
    return getPosition(element);
  }

  function calcBBox(el, isText) {
    var element = getElement(el);
    var s = performance.now();
    var res = element.getBBox();
    var e = performance.now();
    if (isText) {
      window.infoBBox.texts.qt++;
      window.infoBBox.texts.total += e - s;
    } else {
      window.infoBBox.others.qt++;
      window.infoBBox.others.total += e - s;
    }
    return res;
  }

  function resetBBox() {
    window.infoBBox = {
      texts: {
        qt: 0,
        total: 0
      },
      others: {
        qt: 0,
        total: 0
      }
    };
  }

  function printBBox(tag) {
    tag = tag || '';
    if (window.infoBBox.texts.qt > 0) {
      // var textsSec = window.infoBBox.texts.total / 1000;
    }
    if (window.infoBBox.others.qt > 0) {
      // var otherSec = window.infoBBox.others.total / 1000;
    }
  }

  function printExecutionTime( /*tag, start, info, force*/ ) {
    /*var elapsed = this.getDuration(start);
    if (elapsed > 10 || force) {
        var extra = info ? '{' + info + '}' : '';
        var sec = elapsed / 1000;
        console.info('ExecutionTimeFor [', tag, '] >>>', sec.toFixed(2) + 'sec', extra);
    }*/
  }

  function getDuration(start) {
    return performance.now() - start;
  }

  function scale(element, x, y) {
    var elementPos = getTranformationData(element);
    elementPos.sx = x;
    elementPos.sy = y || x;
    applyTransformation(element);
  }

  function rotate(element, angle, rx, ry) {
    if (angle !== 0) {
      var elementPos = getTranformationData(element);
      elementPos.r = (elementPos.r + angle) % 360;
      elementPos.rx = rx != null ? rx : getShape(element).w / 2;
      elementPos.ry = ry != null ? ry : getShape(element).h / 2;
      applyTransformation(element);
    }

    return getTranformationData(element).r;
  }

  function setEllipsis(textNode, width) {
    if (textNode && typeof textNode.data === 'function') {
      textNode.data().ellipsis = width;
    }
  }

  //Recursive apply ellipsis truncate on all text element with a data.ellipsis defined with limit
  function applyEllipsis(element) {
    var el = getElement(element);
    if (el) {
      var texts = el.type === 'text' ? [el] : el.selectAll('text');
      _.each(texts, function (text) {
        var maxWidth = text.data().ellipsis;
        var currentWidth = text.node.getComputedTextLength();
        // Guard current with to be within limit
        if (maxWidth && currentWidth > maxWidth) {
          var charAverageWidth = text.node.getComputedTextLength() / text.node.innerHTML.length;
          var maxCharacters = Math.floor(maxWidth / charAverageWidth);
          var content = text.node.innerHTML;
          content = content.slice(0, maxCharacters - 1 /* space for ...*/ );
          text.node.innerHTML = content + '...';
        }
      });
    }
  }

  function initMultitextPlugin() {
    Snap.plugin(function (Snap, Element, Paper) {
      Paper.prototype.multitext = function (x, y, txt) {
        txt = txt.split('\n');
        var t = this.text(x, y, txt);
        t.selectAll('tspan:nth-child(n+2)').attr({
          dy: '1.2em',
          x: x
        });
        return t;
      };
    });
  }
}
